// Testimonials — replace the example entries with real testimonials.
// Add client logo images to /public/images/testimonials/ and reference them by path.
export const TESTIMONIALS = [
  {
    logo: "/images/clients/jinabakul-forge.png",
    company: "Jinabakul",
    person_name: "Ritesh Kabbur",
    designation: "Plant Head",
    review:
      "Nago International has consistently supplied high-quality industrial lubricants and cutting solutions that have improved our machine performance. Their timely deliveries and technical support make them a reliable business partner.",
  },
  {
    logo: "/images/clients/minco.png",
    company: "Minco India Flow",
    person_name: "Amtamram Naik",
    designation: "Purchase Department",
    review:
      "We appreciate the wide range of industrial products offered by Nago International. Their prompt deliveries, competitive pricing, and professional approach have helped us maintain uninterrupted production.",
  },
  {
    logo: "/images/clients/hughes-precision.png",
    company: "Hughes Precision Technology",
    person_name: "Arun Kumar",
    designation: "Plant Head",
    review:
      "The quality of lubricants and cutting tools supplied by Nago International has consistently met our expectations. Their commitment to customer satisfaction and dependable service has made them one of our preferred suppliers.",
  },
  {
    logo: "/images/clients/indian-cane-power.png",
    company: "Indian Cane Pvt. Ltd.",
    person_name: "Kumar Shanbhag",
    designation: "Production Department",
    review:
      "Nago International provides excellent product recommendations and reliable maintenance support for industrial lubricants. Their products have contributed to smooth machine operation and improved equipment reliability.",
  },
  {
    logo: "/images/clients/tool-holders.png",
    company: "Tool Holder Pvt. Ltd.",
    person_name: "Ram",
    designation: "Purchase Department",
    review:
      "Their extensive range of industrial lubricants, cutting tools, and consumables allows us to source everything from a single trusted supplier. We value their consistent quality, timely deliveries, and professional service.",
  },
  {
    logo: "/images/clients/girnar-precision.png",
    company: "Girnar Precision",
    person_name: "Shridhar",
    designation: "Production Head",
    review:
      "Nago International has been a dependable partner for our manufacturing requirements. Their product quality, on-time deliveries, and responsive support team have helped us maintain efficient production with minimal downtime.",
  },
];
